import React, { useState, useEffect, Suspense, lazy } from "react";
import styled from "styled-components";
import { Pagination, Loader } from "semantic-ui-react";

import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector, shallowEqual, useDispatch } from "react-redux";


import {
  UPDATE_PROD_ORG_CONTRACT_PAGE_NUMBER,
  SG_GET_PROD_ORG_CONTRACT,
  RESET_PROD_ORG_CONTRACT,
} from "constants/actions";

  const OrganizationSelect = lazy(() => import("organizations/OrganizationSelect"));

const List = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();


  let ReloadPage = searchParams.get("reload");
  const [organizationId, setOrganizationId] = useState(null);
  const [results, setResults] = useState([]);
  const [page, setPage] = useState(1);
   const [resetPageLoad, setResetPageLoad] = useState(false);
  // const [loading, setLoading] = useState(false)
  const [totalPages, setTotalPages] = useState(1);

  const { get_prod_org_contract } = useSelector(
    (state) => ({
      get_prod_org_contract: state.prod_org_contract.prod_org_contract,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch({
      type: RESET_PROD_ORG_CONTRACT,
    });
    dispatch({
      type: SG_GET_PROD_ORG_CONTRACT,
    });
  }, [dispatch]);

  useEffect(() => {
    setResults(get_prod_org_contract?.results);
    setPage(get_prod_org_contract?.pageNumber);
    setTotalPages(Math.ceil(get_prod_org_contract?.count / get_prod_org_contract?.page_size));
    if (get_prod_org_contract?.count % get_prod_org_contract?.page_size) {
      setTotalPages(Math.ceil(get_prod_org_contract?.count / get_prod_org_contract?.page_size));
    }
  }, [get_prod_org_contract, page]);

  function handlePageChange(e, { activePage }) {
    setPage(activePage);
    dispatch({
      type: UPDATE_PROD_ORG_CONTRACT_PAGE_NUMBER,
      payload: activePage,
    });
    dispatch({
      type: SG_GET_PROD_ORG_CONTRACT,
      payload: `page=${activePage}`
    });
  }

  function EditTemplate(templateId) {
    navigate(`/app/product/contract/edit/${templateId}`);
  }

  function TemplateDetails(templateId) {
    navigate(`/app/product/contract/details/${templateId}`);
  }

  const handleOrganizationChange = (orgId) => {
    console.log(orgId);
    setOrganizationId(orgId);
    applyFilters(1, orgId);
  };

    const applyFilters = (pageNo = 1, orgId = organizationId,) => {
      // let params = [];
      // if (pageNo) params.push(`page=${pageNo}`);
      // if (orgId) params.push(`organization=${orgId}`);
  const params = `page=${pageNo}&organization=${orgId}`;
  console.log(params);
      // setQueryParams(params);
      dispatch({ type: SG_GET_PROD_ORG_CONTRACT, payload: params });
    };
  return (
    <>
    <Suspense fallback={<Loader active />}>
          <OrganizationSelect 
            changeOrganizationId={setOrganizationId}
            setResetPageLoad={setResetPageLoad} 
            handleOrganizationChange={handleOrganizationChange}
            handleResetQueryPArams={applyFilters}
          />
        </Suspense>
      <TableContainer>
        <Table>
          <thead>
            <tr>
              <th>Organization</th>
              <th>Package</th>
              <th>Package Sort Order</th>
              <th>Price</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {results &&
              results.map((product, index) => (
                <tr key={index}>
                  <td>{product?.organization} - {product?.organization_name}</td>
                  <td>{product?.product_package} - {product?.product_package_name}</td>
                  <td>{product.product_package_sort_order}</td>
                  <td>{product.price} - {product?.price_name}</td>
                  <td>
                    <Clickable onClick={() => EditTemplate(product?.id)}>
                      Edit{" "}
                    </Clickable>{" "}
                    |
                    <Clickable onClick={() => TemplateDetails(product.id)}>
                      Details{" "}
                    </Clickable>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </TableContainer>

      <Pagination
        ellipsisItem={null}
        firstItem={null}
        lastItem={null}
        activePage={page}
        totalPages={totalPages ? totalPages : 0}
        onPageChange={handlePageChange}
      />
    </>
  );
};

export default List;

const TableContainer = styled.div`
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 5px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #f4f4f4;
  }
`;

const Clickable = styled.span`
  color: blue;
  cursor: pointer;
  &:hover {
    color: red;
  }
`;
